import { render, staticRenderFns } from "./TaskCommitment.vue?vue&type=template&id=992a8a96&scoped=true&"
import script from "./TaskCommitment.vue?vue&type=script&lang=js&"
export * from "./TaskCommitment.vue?vue&type=script&lang=js&"
import style0 from "./TaskCommitment.vue?vue&type=style&index=0&id=992a8a96&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992a8a96",
  null
  
)

export default component.exports